/**
 * Sensor Package Mappings
 *
 * Extracted from customer_portal camera_action_editor/camera_settings/settings_mappings.ts.
 * Maps sensor packages to thermal availability and EO sensor lists.
 *
 * @packageDocumentation
 */

import { CameraSettings_EoSensor } from "@skydio/pbtypes/pbtypes/vehicle/skills/mission_camera_settings";

// ============================================================================
// Sensor Package
// ============================================================================

export enum SensorPackage {
  SKYDIO_X10_VT300Z = "Skydio X10 VT300Z",
  SKYDIO_X10_VT300L = "Skydio X10 VT300L",
  SKYDIO_X10_V100L = "Skydio X10 V100L",
}

export const SensorPackageToThermal: Record<SensorPackage, boolean> = {
  [SensorPackage.SKYDIO_X10_VT300Z]: true,
  [SensorPackage.SKYDIO_X10_VT300L]: true,
  [SensorPackage.SKYDIO_X10_V100L]: false,
};

export const SensorPackageToEoSensors: Record<SensorPackage, CameraSettings_EoSensor[]> = {
  [SensorPackage.SKYDIO_X10_V100L]: [
    CameraSettings_EoSensor.R47_CINE,
    CameraSettings_EoSensor.R47_NARROW,
  ],
  [SensorPackage.SKYDIO_X10_VT300Z]: [CameraSettings_EoSensor.R47_NARROW],
  [SensorPackage.SKYDIO_X10_VT300L]: [
    CameraSettings_EoSensor.R47_CINE,
    CameraSettings_EoSensor.R47_NARROW,
  ],
};
